import { DateTime } from "luxon"

import DriverTripTable from "./DriverTripTable.tsx"

export default function Driver({ id }: { id: number }) {
  const asOf = DateTime.now()
    .setZone("America/Chicago")
    .startOf("day")
    .minus({ days: 1 })
    .toJSDate()

  return (
    <div className="grid grid-cols-4 gap-4">
      <div className="rounded-md shadow-sm border col-span-4">
        <DriverTripTable id={id} asOf={asOf} />
      </div>
    </div>
  )
}
